export function isReportOrDashboardPage(pathname: string) {
  const pages = ['/dashboard', '/dashboard/', '/dashboard/relatorios', '/dashboard/relatorios/'];

  const findPage = pages.includes(pathname);

  return findPage;
}
